export interface ZustandSsoStore extends ZustandSsoEntity {
  setDomains: (newDomains: Domain[]) => void;
}

export interface ZustandSsoEntity {
  newDomains: Domain[] | null;
  trigger: EDomainTrigger;
}

export type Domain = {
  id_domain: number;
  url: string;
};

export enum EDomainTrigger {
  Unknown,
  Deposit,
  Immediately,
}
